import { getters, commits, dispatches } from '@/modules/core/app/helpers/store';

export const actions = {
  setWidgetAsRendered({}, widgetId) {
    commits.dashboardExport.setWidgetAsRendered({ widgetId });
    if (getters.dashboardExport.getWidgetsRemaining() === 0) {
      dispatches.export.setExportReady();
    }
  },
  setUnrenderedWidgetIds({}, widgetIds) {
    if (getters.dashboardExport.getWidgetsRemaining() === 0) {
      dispatches.export.setVueBasedChartRender();
    }
    commits.dashboardExport.setUnrenderedWidgetIds({ widgetIds });
  },
  setPaginationRequiredWidgets({}, widgetIds) {
    commits.dashboardExport.setPaginationRequiredWidgets({ widgetIds });
  },
  setWidgetAsReadyToPaginate({}, widgetId) {
    commits.dashboardExport.setWidgetAsReadyToPaginate({ widgetId });
    dispatches.dashboardExport.checkPaginationReady();
  },
  // Evaluate the pagination gate. Must be dispatched both when a widget becomes ready AND
  // when a widget is dropped from the target set (an empty grid) — a drop can satisfy the gate
  // for the remaining widgets, and the drop path does not go through setWidgetAsReadyToPaginate.
  checkPaginationReady({}) {
    if (getters.dashboardExport.widgetsAreReadyToPaginate()) {
      commits.dashboardExport.setPaginationReady();
    }
  },
};
